import { useEffect, useState } from 'react'

export function useDebouncer<T>(value: T, ms = 300): T {
  const [debounced, setDebounced] = useState<T>(value)

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebounced(value)
    }, ms)

    return () => clearTimeout(timeoutId)
  }, [ms, value])

  return debounced
}
